<mat-card class="cardWithShadow">
  <mat-card-header style="align-items: baseline; padding: 24px 24px 0 24px;">
    <div style="display: flex; align-items: baseline; gap: 16px; flex-wrap: wrap;">
      
      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 280px;">
        <mat-label>Buscar Solicitud</mat-label>
        <input matInput (keyup)="applyFilter()" placeholder="Buscar por cliente, local, ticket..." #input>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 220px;" *ngIf="isGruman">
        <mat-label>Filtrar Cliente</mat-label>
        <mat-select [(value)]="selectedClientId" (selectionChange)="onClientFilterChange()">
          <mat-option [value]="null">Todos los clientes</mat-option>
          @for (cliente of clientes; track cliente.id) {
            <mat-option [value]="cliente.id">{{ cliente.nombre }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 120px;">
        <mat-label>Mes</mat-label>
        <mat-select [(value)]="selectedMes" (selectionChange)="onDateFilterChange()">
          <mat-option value="">Todos</mat-option>
          @for (mes of meses; track mes) {
            <mat-option [value]="mes">{{ mes }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 100px;">
        <mat-label>Año</mat-label>
        <mat-select [(value)]="selectedAnio" (selectionChange)="onDateFilterChange()">
          <mat-option value="">Todos</mat-option>
          @for (anio of anios; track anio) {
            <mat-option [value]="anio.toString()">{{ anio }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="hide-hint" style="min-width: 220px;">
        <mat-label>Tipo de Servicio</mat-label>
        
        <mat-select [(value)]="selectedServiceType" (selectionChange)="onServiceTypeChange()">
          
          <mat-select-trigger>
            @if (selectedServiceType) {
              <app-service-badge [label]="selectedServiceType"></app-service-badge>
            } @else {
              Todos los servicios
            }
          </mat-select-trigger>

          <mat-option value="">Todos los servicios</mat-option>
          
          @for (tipo of tiposServicio; track tipo.id) {
            <mat-option [value]="tipo.nombre"> 
              <app-service-badge [label]="tipo.nombre"></app-service-badge>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      
      <form [formGroup]="searchForm" *ngIf="isGruman">
        <mat-form-field appearance="outline" class="hide-hint" style="min-width: 280px;">
          <mat-label>Filtrar por Cliente</mat-label>
          <mat-select formControlName="clienteId">
            <mat-option [value]="">Todos los Clientes</mat-option>
            <ng-container *ngFor="let cliente of clientes">
              <mat-option *ngIf="cliente.nombre.toUpperCase() !== 'GRUMAN'" [value]="cliente.id">
                {{ cliente.nombre }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </form>

      <button mat-icon-button type="button" color="primary" (click)="resetFilters()" matTooltip="Limpiar filtros" style="top: 6px;">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <div style="flex: 1 1 auto;"></div>
    
    <div style="display: flex; align-items: center; gap: 8px;">
      <button mat-stroked-button color="primary" (click)="exportarExcel()">
        <mat-icon>file_download</mat-icon> Exportar
      </button>
    </div>
  </mat-card-header>

  <mat-card-content class="p-24">
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Cargando solicitudes...</p>
    </div>

    <div class="table-responsive m-t-16" [hidden]="loading">
      <table mat-table [dataSource]="dataSource" matSort class="w-100">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>N° Ticket</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>
        <ng-container matColumnDef="cliente">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Cliente</th>
            <td mat-cell *matCellDef="let element">{{ element.client?.nombre }}</td>
        </ng-container>
        <ng-container matColumnDef="local">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Local</th>
            <td mat-cell *matCellDef="let element">{{ element.local?.nombre_local }}</td>
        </ng-container>
        <ng-container matColumnDef="zona">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="f-w-600 f-s-14"> Zona </th>
          <td mat-cell *matCellDef="let element" class="f-s-14"> 
            <span class="p-x-8 p-y-4 bg-light-primary rounded f-w-600 text-primary f-s-12">
              {{ element.zona }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="especialidad">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="f-w-600 f-s-14"> Especialidad </th>
          <td mat-cell *matCellDef="let element" class="f-s-14"> {{ element.especialidad_nombre }} </td>
        </ng-container>
        <ng-container matColumnDef="tipoServicio">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="tipoServicio.nombre">
            Tipo de Servicio
          </th>
          <td mat-cell *matCellDef="let row">
            <app-service-badge [label]="row?.tipoServicio?.nombre"></app-service-badge>
          </td>
        </ng-container>
        <ng-container matColumnDef="fechaVisita">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha Visita</th>
            <td mat-cell *matCellDef="let element">{{ element.fechaVisita | date:'dd/MM/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="tecnico">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Técnico</th>
            <td mat-cell *matCellDef="let element">{{ element.tecnico_asignado ? (element.tecnico_asignado.name + ' ' + element.tecnico_asignado.lastName) : 'N/A' }}</td>
        </ng-container>
        <ng-container matColumnDef="tipoMantenimiento">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
            <td mat-cell *matCellDef="let element"><span>{{ getTipoMantenimientoLabel(element.tipo_mantenimiento) }}</span></td>
        </ng-container>
        <ng-container matColumnDef="observaciones">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Observaciones</th>
            <td mat-cell *matCellDef="let element"><span>{{ element.observaciones || '' }}</span></td>
        </ng-container>
        <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
            <td mat-cell *matCellDef="let element"><span>{{ getEstadoLabel(element.status) }}</span></td>
        </ng-container>
        <ng-container matColumnDef="mesFacturacion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Mes Fact.</th>
            <td mat-cell *matCellDef="let element">{{ element.facturacion?.mes || 'N/A' }}</td>
        </ng-container>
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button color="primary" matTooltip="Ver Detalles" (click)="verDetalle(element)">
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <div class="no-data-message">
              <mat-icon>search_off</mat-icon>
              <p>No se encontraron coincidencias para los filtros aplicados</p>
            </div>
          </td>
        </tr>
      </table>

      
    </div>

    <div class="paginator-container" [hidden]="loading">
      <mat-paginator 
        [length]="totalItems"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 25, 100]"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>